"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

const NAMESPACE = "new-aluminum-extrusion";
const IMAGE_BASE = "/image/new-version/more/AluminumExtrusion/quality-you-can-trust";

const IMAGES = [
	{ src: `${IMAGE_BASE}/quality-you-can-trust-1.webp`, altKey: "qualityImageAlt1" },
	{ src: `${IMAGE_BASE}/quality-you-can-trust-2.webp`, altKey: "qualityImageAlt2" },
	{ src: `${IMAGE_BASE}/quality-you-can-trust-3.jpg`, altKey: "qualityImageAlt3" },
	{ src: `${IMAGE_BASE}/quality-you-can-trust-4.jpg`, altKey: "qualityImageAlt4" },
] as const;

const FEATURES = [
	{ titleKey: "qualityDimensionalTitle", descKey: "qualityDimensionalDesc" },
	{ titleKey: "qualitySurfaceTitle", descKey: "qualitySurfaceDesc" },
	{ titleKey: "qualityMaterialTitle", descKey: "qualityMaterialDesc" },
] as const;

export default function AluminumExtrusionQuality() {
	const t = useTranslations(NAMESPACE);

	return (
		<section className="bg-[#fcfff4] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<header className="mb-6 text-center sm:mb-8 md:mb-10 lg:mb-12">
					<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
						{t("qualityTitle")}
					</h2>
					<p className="text-sm leading-relaxed text-black md:text-base">{t("qualityDesc")}</p>
				</header>

				<div className="grid items-center gap-8 lg:grid-cols-[5fr_6fr] lg:gap-12">
					<div className="grid grid-cols-2 gap-3 sm:gap-4">
						{IMAGES.map((image) => (
							<div key={image.altKey} className="relative aspect-[4/3] w-full overflow-hidden bg-[#f5f7fa]">
								<Image
									src={image.src}
									alt={t(image.altKey)}
									fill
									className="object-cover"
									sizes="(max-width: 1024px) 50vw, 25vw"
								/>
							</div>
						))}
					</div>

					<div className="flex flex-col gap-5 sm:gap-6 md:gap-7">
						{FEATURES.map((feature) => (
							<div key={feature.titleKey}>
								<h3 className="mb-2 text-base font-bold text-themePrimary400 sm:mb-3 sm:text-lg md:text-xl">
									{t(feature.titleKey)}
								</h3>
								<p className="text-sm leading-relaxed text-black md:text-base">{t(feature.descKey)}</p>
							</div>
						))}
					</div>
				</div>
			</div>
		</section>
	);
}
